module.exports = __webpack_public_path__ + "img/dog.efda71df.jpeg";